<textarea
  pTextarea
  [(ngModel)]="txtAreaval"
  [attr.id]="element.name"
  (input)="valueChange($event)"
  (blur)="utilService.flushDebounce(debounceValChanges)"
  [disabled]="disableField"
  class="form-control form-control-sm"
  [rows]="getRowSize()"
  [autoResize]="getAutoResize()"
></textarea>
